import React from 'react';

import { Box, Button } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form';

const PhoneFieldList = ({ control, name, placeholder }) => {
    const { t } = useTranslation();
    const { fields, append, remove } = useFieldArray({
        control,
        name, // "telephones"
    });

    // Opciones ficticias para phone_type (ajusta según tus necesidades)
    const phoneTypeOptions = [
        { label: t('Mobile'), value: 'mobile' },
        { label: t('Work'), value: 'work' },
    ];

    return (
        <>
            {fields.map((field, index) => (
                <Box alignItems="center" display="flex" gap={2} key={field.id}>
                    <ReactHookFormInput
                        control={control}
                        name={`${name}.${index}.telephone`}
                        placeholder={`${placeholder} #${index + 1}`}
                    />
                    <ReactHookFormSelect
                        control={control}
                        name={`${name}.${index}.phone_type`}
                        options={phoneTypeOptions}
                        sx={{ minWidth: '120px' }}
                    />
                    {index > 0 && (
                        <Button
                            color="secondary"
                            onClick={() => remove(index)}
                            variant="text"
                        >
                            {t('Delete')}
                        </Button>
                    )}
                </Box>
            ))}
            <Box sx={{ textAlign: 'right' }}>
                <Button
                    color="secondary"
                    onClick={() => append({ telephone: '', phone_type: '' })}
                    variant="text"
                >
                    {t('Add phone')}
                </Button>
            </Box>
        </>
    );
};

PhoneFieldList.propTypes = {
    control: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
};

export default PhoneFieldList;
